import { render, staticRenderFns } from "./WeightDistributionChart.vue?vue&type=template&id=564a3028&scoped=true&"
import script from "./WeightDistributionChart.vue?vue&type=script&lang=js&"
export * from "./WeightDistributionChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564a3028",
  null
  
)

export default component.exports